import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Navigation: React.FC = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
        document.body.style.overflow = !isMenuOpen ? 'hidden' : '';
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
        document.body.style.overflow = '';
    };

    return (
        <>
            <nav className="nav">
                <div className="nav__container">
                    <Link to="/" className="nav__logo">
                        <img 
                            src="/images/logo-full.png" 
                            alt="DoYourStep" 
                            className="nav__logo-img"
                        />
                    </Link>

                    <div className="nav__links">
                        <Link to="/" className="nav__link">Home</Link>
                        <Link to="/about" className="nav__link">About</Link>
                        <Link to="/pricing" className="nav__link">Pricing</Link>
                        <Link to="/faqs" className="nav__link">FAQs</Link>
                        <Link to="/contact" className="nav__link">Contact us</Link>
                    </div>

                    <div className="nav__actions">
                        <Link to="/login" className="nav__btn nav__btn--outline">
                            Sign in
                        </Link>
                        <Link to="/quiz/doyourstep-quiz" className="nav__btn nav__btn--primary">
                            Do your step →
                        </Link>
                    </div>

                    <button 
                        type="button"
                        className={`nav__burger ${isMenuOpen ? 'nav__burger--active' : ''}`}
                        onClick={toggleMenu}
                        aria-label="Toggle menu"
                    >
                        <span />
                        <span />
                        <span />
                    </button>
                </div>
            </nav>

            <div className={`menu-overlay ${isMenuOpen ? 'menu-overlay--open' : ''}`}>
                <div className="menu-overlay__content">
                    <Link to="/" className="menu-overlay__link" onClick={closeMenu}>
                        Home
                    </Link>
                    <Link to="/about" className="menu-overlay__link" onClick={closeMenu}>
                        About
                    </Link>
                    <Link to="/pricing" className="menu-overlay__link" onClick={closeMenu}>
                        Pricing
                    </Link>
                    <Link to="/faqs" className="menu-overlay__link" onClick={closeMenu}>
                        FAQs
                    </Link>
                    <Link to="/contact" className="menu-overlay__link" onClick={closeMenu}>
                        Contact Us
                    </Link>
                    <Link to="/login" className="menu-overlay__link" onClick={closeMenu}>
                        Sign in
                    </Link>
                    <Link to="/quiz/doyourstep-quiz" className="menu-overlay__btn" onClick={closeMenu}>
                        Do your step →
                    </Link>
                </div>
            </div>
        </>
    );
};

export default Navigation;
